import EntityTypeEnum from 'common/enums/entityTypeEnum'
import { MasterBlockIdType } from 'src/shared/schemas/master-block-id.schema'
import { LatestBlogPostsInterface } from 'common/types/entities/LatestBlogPostsInterface'
import { generateBaseEntity } from 'src/shared/entities/utils/generate-base-entity'

export function createBlogLatestPosts(
  parentId: string,
  masterBlockId?: MasterBlockIdType,
): LatestBlogPostsInterface {
  return {
    ...generateBaseEntity(
      EntityTypeEnum.LatestBlogPosts,
      parentId,
      masterBlockId,
    ),
    maxPosts: 3,
    maxPostsPerRow: 3,
    rowsGap: 30,
    columnsGap: 30,
    showDate: false,
    displayHorizontally: false,
    titleFontSize: 26,
    mobileTitleFontSize: 22,
    titleColor: 'rgba(20, 45, 99, 1)',
    titleAlign: 'left',
    categoriesFontSize: 18,
    categoriesColor: 'rgba(27, 160, 255, 1)',
    categoriesAlign: 'left',
    descriptionFontSize: 22,
    mobileDescriptionFontSize: 18,
    descriptionColor: 'rgba(100, 101, 126, 1)',
    descriptionAlign: 'left',
    dateFontSize: 18,
    dateColor: 'rgba(20, 45, 99, 1)',
    dateAlign: 'left',
    padding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    mobilePadding: {
      paddingTop: 0,
      paddingRight: 0,
      paddingBottom: 0,
      paddingLeft: 0,
    },
    postsReplacement: '%BLOG_LATEST_POSTS%',
    imageMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    titleMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    categoriesMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    descriptionMargin: {
      marginTop: 5,
      marginRight: 0,
      marginBottom: 5,
      marginLeft: 0,
    },
    dateMargin: {
      marginTop: 10,
      marginRight: 0,
      marginBottom: 10,
      marginLeft: 0,
    },
    mobileImageMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileTitleMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileCategoriesMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileDescriptionMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
    mobileDateMargin: {
      marginTop: 0,
      marginRight: 0,
      marginBottom: 0,
      marginLeft: 0,
    },
  }
}
